import { useEffect, useState } from 'react';
import { fetchSiteContent } from '../lib/api';
import * as mock from '../mock';

// Mock fallback shape — used for instant first paint and as a hard
// fallback if the API is briefly unreachable. Mirrors the API response.
const mockContent = {
  navItems: mock.navItems,
  heroVideoId: mock.heroVideoId,
  social: mock.social,
  stats: mock.stats,
  classCategories: mock.classCategories,
  scheduleDays: mock.scheduleDays,
  classPrograms: mock.classPrograms,
  trainers: mock.trainers,
  memberships: mock.memberships,
  testimonials: mock.testimonials,
  reviewStats: mock.reviewStats,
  team: mock.team,
  todaySchedule: mock.todaySchedule,
};

// Module-level cache so multiple components share one fetch.
let cachedContent = null;
let inFlight = null;

export function useSiteContent() {
  const [content, setContent] = useState(cachedContent || mockContent);
  const [source, setSource] = useState(cachedContent ? 'api' : 'mock');

  useEffect(() => {
    if (cachedContent) return;
    if (!inFlight) {
      inFlight = fetchSiteContent()
        .then((data) => {
          cachedContent = { ...mockContent, ...data };
          return cachedContent;
        })
        .catch(() => {
          cachedContent = mockContent;
          return cachedContent;
        });
    }
    let active = true;
    inFlight.then((data) => {
      if (!active) return;
      setContent(data);
      setSource(data === mockContent ? 'mock' : 'api');
    });
    return () => {
      active = false;
    };
  }, []);

  return { content, source };
}
